import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr';
import { push } from 'react-router-redux';
import {
  FLAG_GETTING_BUS_FUEL_GROUPS,
  GET_BUS_FUEL_GROUPS,
  CLEAR_BUS_FUEL_GROUPS,
  FLAG_BUS_FUEL_GROUP_ACTIVITY,
  GET_BUS_FUEL_GROUP,
  POST_BUS_FUEL_GROUP,
  CLEAR_BUS_FUEL_GROUP,
  PUT_BUS_FUEL_GROUP,
} from '../types/traffic';
import { BUS_FUEL_GROUP_ENDPOINT } from '../../config/endpoints';
import {
  DEFAULT_GET_CONFIG,
  DEFAULT_POST_CONFIG,
  DEFAULT_DELETE_CONFIG,
  DEFAULT_PUT_CONFIG,
} from '../../config/rest';
import { isErrorResponse } from '../../utils/error-handlers';
import { BUS_FUEL_GROUP_PATH } from '../../config/paths';

const flagGettingBusFuelGroups = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_BUS_FUEL_GROUPS,
    payload: flag,
  });

const getBusFuelGroups = async (tableFilters) => async (dispatch) => {
  try {
    dispatch(flagGettingBusFuelGroups(true));
    const query = tableFilters;
    const url = `${BUS_FUEL_GROUP_ENDPOINT}?${QueryString.stringify(query)}`;
    const response = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(response, null, dispatch);
    const busFuelGroups = await response.json();
    dispatch({
      type: GET_BUS_FUEL_GROUPS,
      payload: busFuelGroups,
    });
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagGettingBusFuelGroups(false));
  }
};

const clearBusFuelGroups = () => (dispatch) =>
  dispatch({
    type: CLEAR_BUS_FUEL_GROUPS,
  });

const flagBusFuelGroupActivity = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_BUS_FUEL_GROUP_ACTIVITY,
    payload: flag,
  });

const getBusFuelGroup = async (fuelGroupId) => async (dispatch) => {
  try {
    dispatch(flagBusFuelGroupActivity(true));
    const url = `${BUS_FUEL_GROUP_ENDPOINT}/${fuelGroupId}`;
    const response = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(response, null, dispatch);
    const fuelGroup = await response.json();
    dispatch({
      type: GET_BUS_FUEL_GROUP,
      payload: fuelGroup,
    });
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagBusFuelGroupActivity(false));
  }
};

const clearBusFuelGroup = () => (dispatch) =>
  dispatch({
    type: CLEAR_BUS_FUEL_GROUP,
  });

const postBusFuelGroup =
  async ({ name, description, performance, registeredBusList }) =>
  async (dispatch) => {
    try {
      dispatch(flagBusFuelGroupActivity(true));
      const payload = {
        name,
        description,
        performance,
        registeredBusList,
      };

      const url = BUS_FUEL_GROUP_ENDPOINT;
      const response = await fetch(url, {
        ...DEFAULT_POST_CONFIG,
        body: JSON.stringify(payload),
      });
      await isErrorResponse(response, null, dispatch);
      const busFuelGroup = await response.json();
      dispatch({
        type: POST_BUS_FUEL_GROUP,
        payload: busFuelGroup,
      });
      dispatch(push(BUS_FUEL_GROUP_PATH));
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagBusFuelGroupActivity(false));
    }
  };

const deleteBusFuelGroup =
  async ({ busFuelGroupId }) =>
  async (dispatch) => {
    try {
      dispatch(flagBusFuelGroupActivity(true));
      const url = `${BUS_FUEL_GROUP_ENDPOINT}/${busFuelGroupId}`;
      const response = await fetch(url, {
        ...DEFAULT_DELETE_CONFIG,
      });
      await isErrorResponse(response, null, dispatch);
      await response.json();
      dispatch(push(BUS_FUEL_GROUP_PATH));
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagBusFuelGroupActivity(false));
    }
  };

const putBusFuelGroup =
  async (
    busFuelGroupId,
    { name, description, performance, registeredBusList },
  ) =>
  async (dispatch) => {
    try {
      dispatch(flagBusFuelGroupActivity(true));
      const payload = {
        id: busFuelGroupId,
        name,
        description,
        performance,
        registeredBusList,
      };

      const url = `${BUS_FUEL_GROUP_ENDPOINT}/${busFuelGroupId}`;
      const response = await fetch(url, {
        ...DEFAULT_PUT_CONFIG,
        body: JSON.stringify(payload),
      });
      await isErrorResponse(response, null, dispatch);
      const busFuelGroup = await response.json();
      dispatch({
        type: PUT_BUS_FUEL_GROUP,
        payload: busFuelGroup,
      });
      dispatch(push(BUS_FUEL_GROUP_PATH));
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagBusFuelGroupActivity(false));
    }
  };

export {
  flagGettingBusFuelGroups,
  getBusFuelGroups,
  clearBusFuelGroups,
  flagBusFuelGroupActivity,
  getBusFuelGroup,
  postBusFuelGroup,
  clearBusFuelGroup,
  deleteBusFuelGroup,
  putBusFuelGroup,
};
